module.exports = __webpack_public_path__ + "static/media/Screenshot_62.a7511b03.png";